import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';
import SelectAsync from 'react-select/async';
import PersonCard from "../Accountings/PersonCard";
import Letter from "../Secretariat/Letter";
import Contract from "../Contract";
import Meeting from "../Meeting";
import Ordering from "../Ordering/Ordering";
import Letters from "../Secretariat/Letters";
import Meetings from "../Meetings";
import Orderings from "../Ordering/Orderings";
import CrmCaseLogs from "./CrmCaseLogs";
import EmployeeEnterExits from "../HRM/EmployeeEnterExit/EmployeeEnterExits";

export default class CrmCaseDo extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            crmCaseLogType: props.CrmCaseLogType,
            personId: this.isNull(props.PersonId) ? this.defaultGuid() : props.PersonId,
            crmTeamId: this.isNull(props.CrmTeamId) ? null : props.CrmTeamId,
            viewMode: this.isNull(props.ViewMode) ? false : props.ViewMode,
            caller: props.Caller,
            data: null,
            loading: true,
            description: '',
            dueDate: null,
            status: null,
            nextPersonId: this.defaultGuid(),
            nextStepId: this.defaultGuid(),
            attachment: '',
            contactTypeId: 1,
            workingTime: 0,
            messageTemplateId: this.getDefaultGuid(),
            templates: [],
            mergId: ''
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var p1 = this.httpPost("api/v1/common/getsmstemplate", {
            onlySystemTemplates: false,
            useIn: 'crm',
            crmTeams: (this.isBlank(this.crmTeamId) ? '' : this.crmTeamId)
        })
            .then(data => {
                this.state.templates = data.templates;
            });

        var p2 = this.httpPost("api/v1/crm/case/get", {
            id: this.getCurrentFormId(),
            personId: this.state.personId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.companyId = data.global.company.id;
                    this.state.data = data;
                }
            });

        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            })
        })
    }
    setAttachment(_attachment) {
        var ext = _attachment.type;
        if (ext == "image/webp" || ext == "image/gif" || ext == "image/png" ||
            ext == "image/jpeg" || ext == "image/jpg" || ext == "application/pdf"
            || ext == "application/vnd.ms-word" || ext == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || ext == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            || ext == "application/vnd.ms-excel" || ext == "application/x-zip-compressed") {
            this.getBase64(_attachment).then(attachment => {
                this.state.attachment = attachment;
            });
        }
        else {
            this.showErorrMessage("فرمت فایل انتخاب شده نامعتبر است");
        }

    }
    saveResult(e) {
        this.httpPost("api/v1/crm/case/result", {
            id: this.state.data.record.id,
            crmLostReasonId: this.state.data.record.crmLostReasonId,
            result: this.state.data.record.result,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("ثبت نتیجه با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    saveBlacklist(e) {
        this.httpPost("api/v1/crm/case/blacklist", {
            id: this.state.data.record.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("انتقال به بلک لیست انجام شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    saveArchived(e) {
        this.httpPost("api/v1/crm/case/archived", {
            id: this.state.data.record.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("انتقال به آرشیو انجام شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.state.nextStep === 0) {
            this.showErorrMessage("لطفا نتیجه بررسی را مشخص نمایید");
            return;
        }
        if (this.isBlank(this.state.workingTime)) this.state.workingTime = 0;

        if (this.state.crmCaseLogType === 2) {
            this.httpPost("api/v1/crm/case/contact", {
                id: this.state.id,
                personId: this.state.personId,
                description: this.state.description,
                attachment: this.state.attachment,
                contactTypeId: this.state.contactTypeId,
                workingTime: parseInt(this.state.workingTime)
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        this.showSuccessMessage("ثبت مکاتبه و ارتباط با موفقیت ذخیره شد");
                        this.closeMe();
                    }
                    else {
                        this.showErorrMessage(data.message);
                        this.setState({
                            loading: false
                        });
                    }
                });
        }
        else {
            this.httpPost("api/v1/crm/case/do", {
                id: this.state.id,
                description: this.state.description,
                dueDate: this.convertMomentToDb(this.state.dueDate),
                nextStepId: this.state.nextStepId,
                nextPersonId: this.state.nextPersonId,
                fieldValues: this.state.fieldValues,
                attachment: this.state.attachment,
                workingTime: parseInt(this.state.workingTime),
                messageTemplateId: this.state.messageTemplateId,
                personId: this.state.data.record.personId
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                        this.state.caller.refreshData();
                        this.closeMe();
                    }
                    else {
                        this.showErorrMessage(data.message);
                        this.setState({
                            loading: false
                        });
                    }
                });
        }
    }
    merge(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/crm/case/merge", {
            id: this.state.id,
            mergId: this.state.mergId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("تجمیع با موفقیت انجام پذیرفت");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setStatus(e) {
        var s = null;
        this.state.data.record.crmCaseStatus.forEach(record => {
            if (record.id == e) s = record;
        });

        this.state.nextPersonId = this.defaultGuid();
        this.state.nextStepId = e;

        this.state.fieldValues = [];
        s.fields.forEach(f => {
            this.state.fieldValues.push({
                fieldId: f.id,
                value: '',
                valueInt: 0,
                valueDate: null
            });
        })
        this.setState({ status: s });
    }
    setFieldValue(id, e) {
        this.state.fieldValues.forEach(f => {
            if (f.fieldId == id) f.value = e;
        });
    }
    setFieldValueInt(id, e) {
        this.state.fieldValues.forEach(f => {
            if (f.fieldId == id) f.valueInt = e;
        });
    }
    setFieldValueDate(id, e) {
        this.state.fieldValues.forEach(f => {
            if (f.fieldId == id) f.valueDate = this.convertMomentToDb(e);
        });
    }
    setResult(e) {
        this.state.data.record.result = (e.target.value === "" ? null : e.target.value === "1" ? true : false);
        this.setState({ data: this.state.data });
    }
    newMeeting() {
        this.removeKeyDown();
        this.showComponents({
            component: <Meeting
                ReadOnly={false}
                Caller={this}
                RefreshCallerAfterSave={false}
                previousMeetingId={this.defaultGuid()}
                InitPerson={{ id: this.state.data.record.personId, name: this.state.data.record.personName }}
            />,
        });
        
    }
    newOrder() {
        this.removeKeyDown();
        this.showComponents({
            component: <Ordering
                SourceId={1}
                RefreshCallerAfterSave={false}
                Caller={this}
                InitPerson={{ id: this.state.data.record.personId, name: this.state.data.record.personName }} /> });
    }
    newOutLetter() {
        this.removeKeyDown();
        this.showComponents({
            component: <Letter
                Caller={this}
                RefreshCallerAfterSave={false}
                Type={2}
                ReadOnly={false}
                InitPerson={{ id: this.state.data.record.personId, name: this.state.data.record.personName }}
            />
        });
    }
    newInLetter() {
        this.removeKeyDown();
        this.showComponents({
            component: <Letter
                Caller={this}
                RefreshCallerAfterSave={false }
                Type={3}
                ReadOnly={false}
                InitPerson={{ id: this.state.data.record.personId, name: this.state.data.record.personName }}
            />
        });
    }
    newContract() {
        this.removeKeyDown();
        this.showComponents({
            component: <Contract
                Caller={this}
                RefreshCallerAfterSave={false}
                InitPerson={{ id: this.state.data.record.personId, name: this.state.data.record.personName }}
            />
        });
    }    
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                        <div>
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            {!this.state.viewMode && !this.state.data.record.archived && <a onClick={e => this.saveArchived(e)} className="btn btn-sm btn-warning me-2">
                                بایگانی شود
                            </a>}
                                {!this.state.viewMode && !this.state.data.record.blackList && <a onClick={e => this.saveBlacklist(e)} className="btn btn-sm btn-danger me-2">
                                ارسال به لیست سیاه
                                </a>}
                            </div>
                            {this.state.crmCaseLogType === 1 && this.state.data.global.company.mainBussinessType !== 3 && <h4 className="modal-title">
                                پیگیری - {this.state.data.record.id !== this.getDefaultGuid() && <span className="ltr">{this.state.data.record.id}</span>}
                            </h4>}
                            {this.state.crmCaseLogType === 1 && this.state.data.global.company.mainBussinessType === 3 && <h4 className="modal-title">
                                پیگیری {this.state.data.record.id !== this.getDefaultGuid() && <span>{this.state.data.record.personName} در کشت شماره {this.state.data.record.orderingParentFullNumber} و تونل {this.state.data.record.orderingParentProductionLines.join(' و ')} تاریخ سفارش {this.state.data.record.orderingDateString }</span>}
                            </h4>}
                            {this.state.crmCaseLogType === 2 && <h4 className="modal-title">
                                ثبت تماس و مکاتبه
                            </h4>}
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <ul className="nav nav-tabs mt-n3">
                                    <li className="nav-item">
                                        <a className="nav-link active" data-bs-toggle="tab" href="#do"><em className="icon ni ni-info"></em><span>ثبت سابقه</span></a>
                                    </li>
                                    {this.state.crmCaseLogType === 1 &&
                                        <li className="nav-item">
                                            <a className="nav-link" data-bs-toggle="tab" href="#result"><em className="icon ni ni-award"></em><span>نتیجه نهایی</span></a>
                                        </li>
                                    }
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#personcart"><em className="icon ni ni-list-round"></em><span>کارت شخص</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#log"><em className="icon ni ni-wallet-alt"></em><span>سوابق کلیه پیگیری ها و ارتباطات</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#merg"><em className="icon ni ni-wallet-alt"></em><span>انتقال به پیگیری دیگر</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#meetings"><em className="icon ni ni-list-round"></em><span>جلسات</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#orders"><em className="icon ni ni-list-round"></em><span>سفارشات</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#profoma"><em className="icon ni ni-list-round"></em><span>پیش فاکتورها</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#letters"><em className="icon ni ni-list-round"></em><span>نامه ها</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#enterexit"><em className="icon ni ni-list-round"></em><span>ورود و خروجها</span></a>
                                    </li>
                                </ul>
                                <div className="tab-content">
                                    <div className="tab-pane active" id="do">
                                        {!this.state.viewMode && <div className="row">
                                            {this.state.data.record.id !== this.getDefaultGuid() && this.state.crmCaseLogType === 1 && <div className="col-sm-12">
                                                <ul className="text-primary" style={{ "display": "flex", "margin": "10px 0px 25px 0px", "gap": "20px", "background-color": "mintcream", "padding": "15px" }}>
                                                    <li className="hand" onClick={ e=> this.newMeeting() }>تنظیم جلسه</li>
                                                    <li className="hand" onClick={e => this.newOrder()}>ثبت سفارش</li>
                                                    <li className="hand" onClick={e => this.newContract()}>ثبت قرارداد</li>
                                                    <li className="hand" onClick={e => this.newOutLetter()}>ثبت نامه صادره</li>
                                                    <li className="hand" onClick={e => this.newInLetter()}>ثبت نامه وارده</li>
                                                </ul>
                                            </div>}
                                            {this.state.crmCaseLogType === 1 &&
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">وضعیت</label>
                                                        <select defaultValue={this.state.nextStepId} onChange={e => this.setStatus(e.target.value)} className="form-control input-sm">
                                                            <option value={this.defaultGuid()}>انتخاب کنید</option>
                                                            {this.state.data.record.crmCaseStatus.map(r => <option value={r.id}>{r.title}</option>)}
                                                        </select>
                                                    </div>
                                                </div>}

                                            {this.state.crmCaseLogType === 1 &&
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">پیامک</label>
                                                        <select defaultValue={this.state.messageTemplateId} onChange={e => this.state.messageTemplateId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                            <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                            {this.state.templates.map(template =>
                                                                <option value={template.id}>{template.title}</option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>}

                                            {this.state.crmCaseLogType === 2 && <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">روش تماس/مکاتبه</label>
                                                    <select defaultValue={this.state.contactTypeId} onChange={e => this.state.contactTypeId = parseInt(e.target.value)} className="form-control input-sm">
                                                        <option value="1">تماس با تلفن ثابت</option>
                                                        <option value="2">تماس با شماره موبایل</option>
                                                        <option value="3">ایمیل</option>
                                                        <option value="4">پیامک</option>
                                                        <option value="5">نامه نگاری</option>
                                                        <option value="6">دایرکت واتساپ</option>
                                                    </select>
                                                </div>
                                            </div>}
                                            <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">زمان صرف شده(دقیقه)</label>
                                                    <input defaultValue={this.state.workingTime} onChange={e => this.state.workingTime = e.target.value} maxLength="4" autocomplete="off" type="text" className="form-control input-sm" />
                                                </div>
                                            </div>
                                        </div>}

                                        {!this.state.viewMode && this.state.crmCaseLogType === 1 && !this.isNull(this.state.status) && <div className="row mt-2 mb-2">
                                            {this.state.status.hasAsignToPerson === 1 ? <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label for="documentDate" className="title1">مسئول</label><span className="red">*</span>
                                                    <SelectAsync
                                                        style={{ "width": "100%" }}
                                                        defaultValue={null}
                                                        isMulti={false}
                                                        placeholder="انتخاب مسئول"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 3)}
                                                        onChange={e => this.state.nextPersonId = e.value}
                                                    />
                                                </div>
                                            </div> : null}
                                            {this.state.status.hasDueDate === 1 ? <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">تاریخ برای رسیدگی</label><span className="red">*</span>
                                                    <DatePicker
                                                        inputReadOnly={true}
                                                        className="form-control input-sm persian-date"
                                                        placeholder={"تاریخ"}
                                                        isGregorian={false}
                                                        showTodayButton={true}
                                                        timePicker={false}
                                                        onChange={(e) => { this.state.dueDate = e }}
                                                        value={this.getFormatedDateForDatePicker(this.state.dueDate)}
                                                    />
                                                </div>
                                            </div> : null}
                                            {this.state.status.fields.map(field => <div className="col-sm-4" key={field.id}>
                                                <div className="form-group">
                                                    <label className="title1">{field.title}</label>
                                                    {field.format === 1 && <input onChange={e => this.setFieldValue(field.id, e.target.value)} autocomplete="off" type="text" className="form-control input-sm" />}
                                                    {field.format === 2 && <input onChange={e => this.setFieldValueInt(field.id, parseInt(e.target.value))} autocomplete="off" type="number" className="form-control input-sm" />}
                                                    {field.format === 3 && <DatePicker
                                                        inputReadOnly={true}
                                                        className="form-control input-sm persian-date"
                                                        placeholder={"تاریخ"}
                                                        isGregorian={false}
                                                        showTodayButton={true}
                                                        timePicker={false}
                                                        onChange={(e) => { this.setFieldValueDate(field.id, e) }}
                                                    //value={this.getFormatedDateForDatePicker(this.state.dueDate)}
                                                    />}
                                                </div>
                                            </div>)}
                                        </div>}

                                        {!this.state.viewMode && <div className="col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label for="name" className="title1">توضیحات</label>
                                                <textarea defaultValue={this.state.description} onChange={e => this.state.description = e.target.value} autocomplete="off" className="form-control input-sm"></textarea>
                                            </div>
                                        </div>}

                                        {!this.state.viewMode && <div className="col-lg-3">
                                            <div className="form-group">
                                                <label className="form-label">فایل پیوست</label>
                                                <div className="form-control-wrap">
                                                    <input type="file" onChange={(e) => { this.setAttachment(e.target.files[0]) }} />
                                                </div>
                                            </div>
                                        </div>}

                                        {!this.state.viewMode && <div className="col-lg-12" style={{ "display": "flex", "justify-content": "end" }}>
                                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}><span className="shortcut">Esc - </span>انصراف</button>
                                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success ms-2">
                                                <span className="shortcut">F4 - </span> ذخیره
                                            </button>
                                        </div>}

                                        {this.state.crmCaseLogType === 1 && <div className="mt-4">
                                            <h4 className="mt-2" style={{ "height": "45px" }}>سوابق این پیگیری</h4>
                                            <div className="row g-gs mb-4">
                                                {this.state.data.record.logs.map((record, index) =>
                                                    <div className="col-sm-12 col-lg-12 col-xxl-3" style={{ "margin-top": "5px" }}>
                                                        <div className="card card-bordered h-100">
                                                            <div className="card-inner">
                                                                <div className="project">
                                                                    <div>
                                                                        <a className="hand project-title">
                                                                            <div className="project-info">
                                                                                <h6 className="title">
                                                                                    {record.userName} {!this.isBlank(record.kartablName) && [<em className="icon ni ni-chevron-right-circle"></em>, " " + record.kartablName]}
                                                                                    <span className="badge rounded-pill bg-danger">{record.typeString}</span>
                                                                                    <span className="badge rounded-pill bg-primary">{record.contactTypeString}</span>
                                                                                </h6>
                                                                                {!this.isBlank(record.personActionString) && <p>{record.personActionString}</p>}
                                                                                {(!this.isBlank(record.currentStatusString) || !this.isBlank(record.nextStatusString)) && <p>{record.currentStatusString} <em className="icon ni ni-chevron-right-circle"></em> {record.nextStatusString}</p>}
                                                                                <span style={{ "position": "absolute", "left": "1rem", "top": "1rem" }} className="sub-text"><em className="icon ni ni-calender-date"></em> {record.date}</span>
                                                                                {!this.isBlank(record.dueDate) && <span style={{ "position": "absolute", "left": "1rem", "top": "3rem" }} className="text-warning"><em className="icon ni ni-calender-date"></em> {record.date}</span>}
                                                                                {!this.isBlank(record.attachmentUrl) && <a href={record.attachmentUrl} target="_blank">مشاهده فایل پیوست</a>}
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    <div className="project-details">
                                                                        {record.fieldValues.map(record => <p><b>{record.title}: </b>{record.value}</p>)}
                                                                        <p>{record.description}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>}

                                    </div>
                                    {!this.state.viewMode && this.state.crmCaseLogType === 1 &&
                                        <div className="tab-pane" id="result">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">نتیجه نهایی</label>
                                                        <select defaultValue={this.state.data.record.result === null ? "" : this.state.data.record.result ? "1" : "2"} onChange={e => this.setResult(e)} className="form-control input-sm">
                                                            <option value="">نامشخص</option>
                                                            <option value="1">موفق - نتیجه حاصل شده</option>
                                                            <option value="2">نا موفق - نتیجه حاصل نشده</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {this.state.data.record.result === false && <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">علت عدم نتیجه</label>
                                                        <select defaultValue={this.state.data.record.crmLostReasonId} onChange={e => this.state.data.record.crmLostReasonId = (e.target.value)} className="form-control input-sm">
                                                            <option value={this.getDefaultGuid()}>مشخص نشده</option>
                                                            {this.state.data.record.crmLostReasons.map(item => <option value={item.id}>{item.title}</option>)}
                                                        </select>
                                                    </div>
                                                </div>}
                                            </div>
                                            <div className="col-lg-12" style={{ "display": "flex", "justify-content": "end" }}>
                                                <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}><span className="shortcut">Esc - </span>انصراف</button>
                                                <button type="submit" onClick={e => this.saveResult(e)} className="btn btn-success ms-2">
                                                    ذخیره
                                                </button>
                                            </div>
                                        </div>
                                    }
                                    <div className="tab-pane" id="personcart">
                                        <PersonCard PersonId={this.state.data.record.personId} Inline={true} ShowMeetingsHistory={false} ShowCrmLogHistory={false} />
                                    </div>
                                    <div className="tab-pane" id="log">
                                        <CrmCaseLogs PersonId={this.state.data.record.personId}  />
                                    </div>
                                    <div className="tab-pane" id="merg">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label for="name" className="title1">شماره پیگیری که میخواهید بر روی آن پیگیری منتقل شود را وارد نمایید</label>
                                                    <input defaultValue={this.state.mergId} onChange={e => this.state.mergId = e.target.value} maxLength="40" autocomplete="off" type="text" className="form-control input-sm ltr" />
                                                </div>
                                            </div>
                                            <div className="col-lg-12" style={{ "display": "flex", "justify-content": "end" }}>
                                                <button type="submit" onClick={e => this.merge(e)} className="btn btn-success ms-2">
                                                    انتقال و تجمیع
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="meetings">
                                        <Meetings ForMe={false} PersonId={this.state.data.record.personId} Inline={true} />
                                    </div>
                                    <div className="tab-pane" id="orders">
                                        <Orderings Type={1} Department={"acc"} PersonId={this.state.data.record.personId} Inline={true} />
                                    </div>
                                    <div className="tab-pane" id="profoma">
                                        <Orderings Type={2} Department={"acc"} PersonId={this.state.data.record.personId} Inline={true} />
                                    </div>
                                    <div className="tab-pane" id="letters">
                                        <Letters CallerSection="my" Type={0} ForMe={false} PersonId={this.state.data.record.personId} Inline={true} LetterFolderId={this.getDefaultGuid()} />
                                    </div>
                                    <div className="tab-pane" id="enterexit">
                                        <EmployeeEnterExits PersonId={this.state.data.record.personId} Inline={true} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}